export const getHolidayPayload = (
  switchHoliday: boolean,
  formData: any,
  enabled: boolean,
) => {
  const open = formData?.[`open-Holiday`];
  const close = formData?.[`close-Holiday`];

  if (!enabled) {
    return {
      day: "Holiday",
      enabled: false,
      open: null,
      close: null,
    };
  }
  if (enabled && !switchHoliday) {
    return {
      day: "Holiday",
      enabled: true,
      open: null,
      close: null,
    };
  }

  return {
    day: "Holiday",
    enabled: true,
    open,
    close,
  };
};
